// Use the same container and breakpoints for loaded content and its placeholder.
export const partnerDetailLayout = {
  page: 'partner-detail-page max-w-6xl mx-auto p-4 md:p-6 space-y-6 pb-16',
  navigation: 'flex flex-wrap items-center justify-between gap-4',
  hero: 'partner-detail-hero world-panel relative overflow-hidden',
  banner: 'partner-detail-banner relative h-32 sm:h-44 w-full overflow-hidden',
  identity: 'p-6 pt-0 relative z-10 flex flex-col md:flex-row items-center md:items-end gap-6 text-center md:text-left',
  columns: 'grid grid-cols-1 lg:grid-cols-3 gap-6',
  offers: 'lg:col-span-2 space-y-4',
};
